// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:wght@700;800&family=Inter:wght@300;400&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100vw;
  height: 100vh;
  z-index: 99999;
  background: linear-gradient(180deg, #ffffff 0%, #c5c8f0 100%);
  font-family: "Inter", sans-serif;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

.splash-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.logo-wrap {
  opacity: 0;
  transform: scale(0.6) translateY(20px);
  animation: logoIn 0.8s cubic-bezier(0.34, 1.56, 0.64, 1) 0.3s forwards;
}

.logo-wrap img {
  width: 100px;
  height: 100px;
  object-fit: contain;
  filter: drop-shadow(0 8px 24px rgba(26, 42, 94, 0.15));
}

.app-title {
  font-family: "Montserrat", sans-serif;
  font-weight: 800;
  font-size: 2.6rem;
  color: #000;
  letter-spacing: -0.5px;
  opacity: 0;
  transform: translateY(16px);
  animation: slideUp 0.6s cubic-bezier(0.22, 1, 0.36, 1) 1s forwards;
}

.app-tagline {
  font-family: "Inter", sans-serif;
  font-weight: 300;
  font-size: 0.92rem;
  color: #555b6e;
  letter-spacing: 0.4px;
  text-align: center;
  max-width: 270px;
  opacity: 0;
  transform: translateY(10px);
  /* Delay tagline until after logo and title */
  animation: slideUp 0.6s cubic-bezier(0.22, 1, 0.36, 1) 1.6s forwards;
}

.loader-bar-wrap {
  margin-top: 52px;
  width: 48px;
  height: 3px;
  border-radius: 2px;
  background: rgba(26, 42, 94, 0.1);
  overflow: hidden;
  opacity: 0;
  animation: fadeIn 0.4s ease 1.8s forwards;
}

.loader-bar {
  height: 100%;
  width: 0%;
  background: linear-gradient(90deg, #1a2a5e, #4a5fc4);
  border-radius: 2px;
  animation: loadFill 1.8s ease-in-out 2s forwards;
}

@keyframes logoIn {
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}
@keyframes slideUp {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes fadeIn {
  to {
    opacity: 1;
  }
}
@keyframes loadFill {
  0% {
    width: 0%;
  }
  60% {
    width: 75%;
  }
  100% {
    width: 100%;
  }
}
.web-splash-background {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: white;
  z-index: 100002;
  opacity: 1;
  transition: opacity 0.6s ease-out;
}
.web-splash-background.hiding {
  opacity: 0;
}

.splash-position {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 100001;
  overflow: hidden;
  background-color: inherit;
}

.fadeIn {
  animation-name: fadeIn;
  animation-duration: 1000ms;
}

@media screen and (max-width: 700px) {
  .imgSrc {
    transform: scale(1.5);
  }
}`, "",{"version":3,"sources":["webpack://./src/app/core/components/splash/splash.component.scss"],"names":[],"mappings":"AAEA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;EACA,aAAA;EACA,cAAA;EACA,6DAAA;EACA,gCAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAAF;;AAGA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AAAF;;AAGA;EACE,UAAA;EACA,sCAAA;EACA,sEAAA;AAAF;;AAGA;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,sDAAA;AAAF;;AAGA;EACE,qCAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;EACA,sBAAA;EACA,UAAA;EACA,2BAAA;EACA,kEAAA;AAAF;;AAGA;EACE,gCAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,UAAA;EACA,2BAAA;EACA,6CAAA;EACA,oEAAA;AAAF;;AAGA;EACE,gBAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,iCAAA;EACA,gBAAA;EACA,UAAA;EACA,yCAAA;AAAF;;AAEA;EACE,YAAA;EACA,SAAA;EACA,oDAAA;EACA,kBAAA;EACA,gDAAA;AACF;;AAEA;EACE;IAAK,UAAA;IAAY,iCAAA;EAGjB;AACF;AAFA;EACE;IAAK,UAAA;IAAY,wBAAA;EAMjB;AACF;AALA;EACE;IAAK,UAAA;EAQL;AACF;AAPA;EACE;IAAO,SAAA;EAUP;EATA;IAAO,UAAA;EAYP;EAXA;IAAO,WAAA;EAcP;AACF;AAbA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,eAAA;EACA,UAAA;EACA,iCAAA;AAeF;AAbE;EACE,UAAA;AAeJ;;AAZA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;AAeF;;AAZA;EACE,sBAAA;EACA,0BAAA;AAeF;;AAbA;EACE;IACE,qBAAA;EAgBF;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@700;800&family=Inter:wght@300;400&display=swap');\n\n:host {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  width: 100vw;\n  height: 100vh;\n  z-index: 99999;\n  background: linear-gradient(180deg, #ffffff 0%, #c5c8f0 100%);\n  font-family: 'Inter', sans-serif;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.splash-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 16px;\n}\n\n.logo-wrap {\n  opacity: 0;\n  transform: scale(0.6) translateY(20px);\n  animation: logoIn 0.8s cubic-bezier(0.34, 1.56, 0.64, 1) 0.3s forwards;\n}\n\n.logo-wrap img {\n  width: 100px;\n  height: 100px;\n  object-fit: contain;\n  filter: drop-shadow(0 8px 24px rgba(26, 42, 94, 0.15));\n}\n\n.app-title {\n  font-family: 'Montserrat', sans-serif;\n  font-weight: 800;\n  font-size: 2.6rem;\n  color: #000;\n  letter-spacing: -0.5px;\n  opacity: 0;\n  transform: translateY(16px);\n  animation: slideUp 0.6s cubic-bezier(0.22, 1, 0.36, 1) 1.0s forwards;\n}\n\n.app-tagline {\n  font-family: 'Inter', sans-serif;\n  font-weight: 300;\n  font-size: 0.92rem;\n  color: #555b6e;\n  letter-spacing: 0.4px;\n  text-align: center;\n  max-width: 270px;\n  opacity: 0;\n  transform: translateY(10px);\n  /* Delay tagline until after logo and title */\n  animation: slideUp 0.6s cubic-bezier(0.22, 1, 0.36, 1) 1.6s forwards;\n}\n\n.loader-bar-wrap {\n  margin-top: 52px;\n  width: 48px;\n  height: 3px;\n  border-radius: 2px;\n  background: rgba(26, 42, 94, 0.1);\n  overflow: hidden;\n  opacity: 0;\n  animation: fadeIn 0.4s ease 1.8s forwards;\n}\n.loader-bar {\n  height: 100%;\n  width: 0%;\n  background: linear-gradient(90deg, #1a2a5e, #4a5fc4);\n  border-radius: 2px;\n  animation: loadFill 1.8s ease-in-out 2.0s forwards;\n}\n\n@keyframes logoIn {\n  to { opacity: 1; transform: scale(1) translateY(0); }\n}\n@keyframes slideUp {\n  to { opacity: 1; transform: translateY(0); }\n}\n@keyframes fadeIn {\n  to { opacity: 1; }\n}\n@keyframes loadFill {\n  0%   { width: 0%; }\n  60%  { width: 75%; }\n  100% { width: 100%; }\n}\n.web-splash-background {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: white;\n  z-index: 100002;\n  opacity: 1;\n  transition: opacity 0.6s ease-out;\n\n  &.hiding {\n    opacity: 0;\n  }\n}\n.splash-position {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  z-index: 100001;\n  overflow: hidden;\n  background-color: inherit;\n}\n\n.fadeIn {\n  animation-name: fadeIn;\n  animation-duration: 1000ms;\n}\n@media screen and (max-width: 700px) {\n  .imgSrc {\n    transform: scale(1.5);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
